/* whiteboxSecret2.ts */

const _a = [0x11, 0x41, 0x1a, 0x46, 0x26, 0x1c, 0x38, 0x23, 0x25];
const _b = [0x70, 0x54, 0x2d, 0x7a, 0x56, 0x76, 0x53, 0x44, 0x2c];
const _c = [0x13, 0x55, 0x01, 0x36, 0x56, 0x1a, 0x39, 0x50, 0x39];
const _d = [0x66, 0x07, 0x3e, 0x0f, 0x67, 0x06, 0x66, 0x04, 0x60];

const _m = [0x72, 0x1e, 0x63, 0x55];

const _r = (x: number, y: number) => (x + 256) ^ y;
const _g = (arr: number[], k: number) => new Uint8Array(arr.map(v => _r(v, k)));

export const _S1 = (): Uint8Array => {
  const p0 = _g(_a, _m[0]);
  const p1 = _g(_b, _m[1]);
  const p2 = _g(_c, _m[2]);
  const p3 = _g(_d, _m[3]);

  const o = new Uint8Array(p0.length + p1.length + p2.length + p3.length);

  let i = 0;
  o.set(p0, i); i += p0.length;
  o.set(p1, i); i += p1.length;
  o.set(p2, i); i += p2.length;
  o.set(p3, i);

  return o;
};
